import SEO from './SEO';

/**
 * Shared editorial layout for legal pages.
 * Keeps the luxury cream / charcoal palette while remaining accessible
 * (long-form reading, generous spacing, semantic structure).
 */
const LegalLayout = ({ title, description, path, updated, children, testId }) => (
  <div data-testid={testId} className="min-h-screen bg-[#FDFBF7]">
    <SEO
      title={title}
      description={description}
      path={path}
      keywords="Gate 33 legal, NPDS mentions légales, Gate 33 CGV, Gate 33 RGPD, private aviation training legal"
    />

    <section className="pt-32 pb-12 border-b border-[#E5E0D8]">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <span className="overline inline-block mb-6">Legal</span>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight leading-tight text-[#0F0F0F] mb-6">
          {title}
        </h1>
        {updated && (
          <p className="text-sm text-[#5A5A5A]">Last updated: {updated}</p>
        )}
      </div>
    </section>

    <section className="py-16">
      <div className="max-w-3xl mx-auto px-6 md:px-12 legal-content">
        {children}
      </div>
    </section>
  </div>
);

export default LegalLayout;
